<template>
    <div>
      
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/picture/banner/B5.jpg);" >
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                          <!-- 资料下载 -->
                      {{ $t('header.downloads') }}
                    </h1>
                    <h3>
                         <!-- 奥太电气智能制造产品与方案助力企业加速数字化转型升级 -->
                        {{ $t('resource.resource_download_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'mb_home' }">
                            <!-- 首页 -->
                             {{ $t('header.home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item >
                            <!-- 资料下载 -->
                             {{ $t('header.downloads') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
        <!-- 内容 -->
        <section class="project-page" style="padding: 0 0;">
            <div class="container">
                <div class="row">
                    <div class="menu_row row_bg">
                        <div class="menu_item " v-for="(item,index) in typeList" :key="index" @click="getTypeData(item)" :class="downType==item.type ? 'menu_item_selected': ''" >
                            {{ item.label }}
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                 
                    <div class="content_row row_page row_bg">
                        <div v-if="tableData.length" style="height: 100%; width: 100%;">
                            <div class="table_div" >
                                <table  >
                                    <tbody>
                                        <tr v-for="(item,index) in tableData" :key="index" class="tr_div">
                                            <td  class="td_div" >
                                                {{ item.name }}
                                                <!-- {{ $t(`resource.${item.i18n_name}`) }} -->
                                            </td>
                                            <td  class="td_action">
                                                
                                                <!-- <div v-if="downType == 'video'"><a @click="handleVideo(item)"  style="color: var(--notech-gray);"> <i style="font-size: var(--font-size-24)" class="el-icon-video-play"></i></a></div>
                                                <div v-else><a target="_blank" :href="item.downUrl" > <i style="font-size: var(--font-size-24)" class="el-icon-download"></i></a></div> -->
                                                <div v-if="item.type == 'video'"><a @click="handleVideo(item)"  style="color: var(--notech-gray);"> <i style="font-size: var(--font-size-24)" class="el-icon-video-play"></i></a></div>
                                                <div v-if="item.type == 'program'"><a target="downloadFile" download :href="item.program" > <i style="font-size: var(--font-size-24)" class="el-icon-download"></i></a></div>
                                                <!-- <div v-if="item.type == 'view'"><a target="_blank" :href="item.viewUrl" > <i style="font-size: var(--font-size-24)" class="el-icon-view"></i></a></div> -->
                                                <div v-if="item.type == 'view'"><a target="downloadFile" :href="item.viewUrl" > <i style="font-size: var(--font-size-24)" class="el-icon-download"></i></a></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table_pagination" >
                                    <div  class="blog-pagination justify-content-center">
                                        <el-pagination
                                            background
                                            layout="prev, pager, next"
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="queryParam.pageNum"
                                            :page-size="queryParam.pageSize"
                                            :total="total"
                                        >
                                        </el-pagination>
                                </div>
                            </div>
                        </div>
                        <div v-else class="row_empty">
                            <el-empty :image-size="200"></el-empty>
                        </div>
                    </div>
                  
                </div>
               
            </div>
        </section>
        <div v-if="dialogVisible">
            <el-dialog  :visible.sync="dialogVisible" @closed="handleClose" >
                <video style="width: 900px;" ref="videoPlayer" :playsinline="true" autoplay="autoplay" loop="loop" :src="videoSrc" controls=""></video>
            </el-dialog>
        </div>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbResourceList',
    mixins: [MixinsList],
    components: { },
    data () {
        return {
            typeList: [
                { type: 'illustrate', label:  this.$t('resource.resource_type_illustrate'), },  // '说明书'
                { type: 'material', label: this.$t('resource.resource_type_material')  },  // '样本资料',
                // { type: 'video', label: '宣传视频', },
                { type: 'program', label:  this.$t('resource.resource_type_program') }   // '应用程序',
             ], 
            downType: "",
            queryParam: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            tableData: [],
            dialogVisible: false,
            videoSrc: "",
            list: {},
        }
    },
    created() { },
    mounted () {
        this.getTypeData(this.typeList[0])
    },
    methods: {
        getTypeData(item) {
            this.downType = item.type
          
            this.getList()
        },
        // 数据
        async getList() {
          

           try {
               let result = {}
                if( this.list && Object.keys(this.list).length > 0) {
                    result = this.list
                } else {
                    result = await loadData('down', this.lang)
                    this.list = result
                }
            
             
                console.log("result",result)
                var arr = JSON.parse(JSON.stringify(result[this.downType]))  
                this.total = arr.length
                var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
                this.tableData = arr.splice(p,this.queryParam.pageSize)
           } catch (error) {
               console.log("error",error)
           }
           

        },
        handleSizeChange(i, j) {
            Object.assign(this.queryParam, { pageSize: i })
            this.getList()
        },
        handleCurrentChange(i, j) {
            Object.assign(this.queryParam, { pageNum: i })
            this.getList()
        },
        // 打开视频
        handleVideo(item) {
            this.videoSrc = item.downUrl
            this.dialogVisible = true
        },
        handleClose() {
            
            let myPlayer = this.$refs.videoPlayer.player;
            console.log("1111111", myPlayer)
            myPlayer.pause()


            // this.dialogVisible = false
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}
::v-deep iframe body header {
    display: none ;
}

/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    /* font-size: var(--font-size-16); */
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}

.row_bg {
    position: relative;
    background: #fff;
    box-shadow: 0 5px 52px 0 rgba(19, 55, 159, 0.16);
    transition: all 0.36s;
}

.row_page {
    height: 650px;
    display: flex;
    justify-content: space-between;
}
.menu_row {
    width: 100%;
    padding: 15px;
    display: flex;
    justify-content: space-between;
}
.menu_item {
    width: 30%;
    border: 1px solid var(--notech-bdr-color);
    font-weight: 700;
    cursor: pointer;
    font-size: 18px;
    text-align: center;
    padding: 5px;
}
.menu_item_selected {
    color: #fff;
    background-color: var(--notech-base);
}







.content_row {
    margin-top: 30px;
    max-height: 100%;
    width: 100%;
    padding: 28px 15px;
}
.table_div {
    width: 100%;
    border-collapse: collapse; 
    height: calc(100% - 50px);
}
.table_pagination {
    padding-top: 10px;
    height: 50px;
}
.table_div table {
    width: 100%;
}
.tr_div {
    border-bottom: 1px solid #EBEEF5; 
    border-top: 1px solid #EBEEF5;
}
.tr_div:hover{
    background: #FAFAFA;
}
.td_div {
    /* font-size: var(--font-size-20); */
    /* font-size: var(--font-size-18); */
    font-size: 16px;
    padding: 10px;
    width: 85%; 
    height: 40px; 
}
.td_action {
    cursor: pointer;
    color: #409EFF;
    width: 15%;  
    text-align: center;
}
.row_empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}



::v-deep .el-dialog {
    box-shadow: none;
		background: transparent;

	}
    ::v-deep .el-dialog__headerbtn .el-dialog__close {
		color: var(--notech-white) !important;
	}
</style> 
